export type PartyEntityKind = "individual" | "business";

export const PARTY_ENTITY_KIND_VALUES = ["individual", "business"] as const;

export const PARTY_ENTITY_KIND_LABELS: Record<PartyEntityKind, string> = {
  individual: "Individual",
  business: "Business",
};

export function normalizePartyEntityKind(raw: string | boolean | number | null | undefined): PartyEntityKind {
  if (raw === true || raw === 1) return "business";
  const key = String(raw ?? "")
    .trim()
    .toLowerCase();
  if (key === "business" || key === "company") return "business";
  return "individual";
}

export function partyEntityKindLabel(raw: string | boolean | number | null | undefined): string {
  return PARTY_ENTITY_KIND_LABELS[normalizePartyEntityKind(raw)];
}

export function partyEntityKindFieldLabel(role: "customer" | "supplier" | "investor"): string {
  if (role === "customer") return "Customer Type";
  if (role === "supplier") return "Supplier Type";
  return "Investor Type";
}
